<script setup>
  import { ref, computed, onMounted, onErrorCaptured } from 'vue';
  import { useProForecastStore } from '@/stores/ProForecastStore';
  import { useUserStore } from '@/stores/UserStore';
  import ProForecast from '@/components/ProForecast.vue';
  import ErrorBlock from '@/components/ErrorBlock.vue';
  import useContainerConfigurationGlobals from '@/composables/useContainerConfigurationGlobals';
  import ModalSiteSettings from '@/components/ModalSiteSettings.vue';
  import ModalBrandPromo from '@/components/ModalBrandPromo.vue';
  import useSettingsGlobals from '@/composables/useSettingsGlobals';

  const { $PRO_FORECAST } = useContainerConfigurationGlobals();
  const { $PROMO_MODAL_ALLOWED } = useSettingsGlobals();   

  const proForecastStore = useProForecastStore();
  const userStore = useUserStore();

  await proForecastStore.getProForecast($PRO_FORECAST.pro_forecast_id);
  await proForecastStore.getForecasters();

  const loadFooterAd = ref(false);
  const error = ref(null);

  const showPromoModal = computed(() => userStore.messages && userStore.messages.length > 0 && parseInt(userStore.nonTrialMemberLevel) < 49 && $PROMO_MODAL_ALLOWED);

  onMounted(() => {
    loadFooterAd.value = true;
  });

  onErrorCaptured((e) => {
    console.warn(e);

    error.value = { 
      title: `There was a problem loading the Pro Forecast (${$PRO_FORECAST.pro_forecast_id})`,
      message: `Please try again later.`,
      errorText: e.message
    }

    console.warn('There was an error retrieving the Pro Forecast.', e);

    return false;
  })  
</script>

<template>
  <ErrorBlock v-if="error" :error="error" />
  <ProForecast ref="pro-forecast-container" v-else />
  <Suspense>
    <ModalSiteSettings />
  </Suspense>  
  <ModalBrandPromo v-if="showPromoModal" />
</template>